import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "footer-legal-links" };
import PButton from 'primevue/button';
import { vDataLink } from '../utils/data-link-directive';
export default /*@__PURE__*/ _defineComponent({
    __name: 'footer-legal-links',
    props: {
        links: { default: () => [{
                    label: 'Copyright',
                    url: 'https://www.curtin.edu.au/copyright-statement/'
                }, {
                    label: 'Disclaimer',
                    url: 'https://www.curtin.edu.au/disclaimer-of-liability/'
                }, {
                    label: 'Privacy',
                    url: 'https://www.curtin.edu.au/about/governance/privacy/'
                }, {
                    label: 'Accessibility',
                    url: 'https://www.curtin.edu.au/accessibility/'
                }, {
                    label: 'Complaints',
                    url: 'https://www.curtin.edu.au/integrityandstandards/complaints/'
                }] }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                        return _withDirectives((_openBlock(), _createBlock(_unref(PButton), {
                            key: link.url,
                            as: "a",
                            variant: "link",
                            href: link.url,
                            title: link.tooltip,
                            rel: "noopener",
                            class: "footer-link"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.label), 1)
                            ]),
                            _: 2
                        }, 1032, ["href", "title"])), [
                            [_unref(vDataLink), { area: 'oasis-footer', category: 'legal-link', link }]
                        ]);
                    }), 128))
                ])
            ]));
        };
    }
});
